import * as React from "react";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
import MessageIcon from "@material-ui/icons/Message";
import DriveEta from "@material-ui/icons/Motorcycle";
import LocalOffer from "@material-ui/icons/CardTravel";
import BusinessIcon from "@material-ui/icons/Business";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import AssignmentIcon from "@material-ui/icons/Assignment";
import RedeemIcon from "@material-ui/icons/Redeem";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import AppsIcon from "@material-ui/icons/Apps";
import { Link } from "react-router-dom";
import { MenuItem, Tooltip } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";

interface IMenuProps {
  clickMenu: (index: number) => void;
  selectedIndex: number;
}

const MenuList: React.SFC<IMenuProps> = (props: IMenuProps) => {
  const { clickMenu, selectedIndex } = props;

  const items = [
    {
      titleTool: "Carreras",
      textPrimary: "Carreras",
      path: "/",
      icon: <InboxIcon />,
    },
    {
      titleTool: "Delivery",
      textPrimary: "Delivery",
      path: "/delivery",
      icon: <ShoppingCartIcon />,
    },
    {
      titleTool: "Clientes",
      textPrimary: "Clientes",
      path: "/client",
      icon: <PeopleIcon />,
    },
    {
      titleTool: "Choferes",
      textPrimary: "Choferes",
      path: "/driver",
      icon: <DriveEta />,
    },
    {
      titleTool: "Admins.",
      textPrimary: "Admins.",
      path: "/admin",
      icon: <LocalOffer />,
    },
    {
      titleTool: "Sucursales",
      textPrimary: "Sucursales",
      path: "/branch",
      icon: <BusinessIcon />,
    },
    {
      titleTool: "Empresas",
      textPrimary: "Empresas",
      path: "/company",
      icon: <BusinessCenterIcon />,
    },
    {
      titleTool: "Categorias",
      textPrimary: "Categorias",
      path: "/category",
      icon: <AppsIcon />,
    },
    {
      titleTool: "Productos",
      textPrimary: "Productos",
      path: "/product",
      icon: <RedeemIcon />,
    },
    {
      titleTool: "Mensaje",
      textPrimary: "Enviar mensaje",
      path: "/message",
      icon: <MessageIcon />,
    },
    {
      titleTool: "Reportes",
      textPrimary: "Reportes",
      path: "/reports",
      icon: <AssignmentIcon />,
    },
  ];

  return (
    <div>
      {items.map((element, index) => {
        const { titleTool, textPrimary, path, icon } = element;
        return (
          <Link to={path} key={index}>
            <Tooltip title={titleTool} placement="bottom">
              <MenuItem
                button
                selected={selectedIndex === index}
                onClick={() => clickMenu(index)}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={textPrimary} />
              </MenuItem>
            </Tooltip>
          </Link>
        );
      })}
    </div>
  );
};

export default MenuList;



// WEBPACK FOOTER //
// ./src/components/MenuList.tsx